export default "__VITE_ASSET__BFPbkypN__"